import { MerchType } from '@api';
import { TouringCardTable, TouringCardTableBody } from '@common';
import { VenueMerchTableRow } from './components';
import { venueMerchRows } from './data';

type VenueMerchTablePropsType = {
  venueMerch: MerchType;
};

export const VenueMerchTable: React.FC<VenueMerchTablePropsType> = ({
  venueMerch,
}) => {
  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {venueMerchRows.map((row) => (
          <VenueMerchTableRow
            key={row.label}
            venueMerch={venueMerch}
            row={row}
          />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};

